import { createTheme } from "@mui/material/styles";
import {
  MuiButton,
  MuiTypography,
  MuiAvatar,
  MuiLink,
  MuiTextField,
  MuiDivider,
  MuiDialog,
  MuiTable,
  MuiFormControl,
  MuiAutocomplete,
  MuiChip,
} from "Theme/Themecomponents";

const theme = createTheme({
  palette: {
    primary: {
      // main: "#11C1B0",
      main: "#7BC044",
    },
    secondary: {
      main: "#5A6872",
    },
    greybtn: {
      main: "#DDDDDD",
    },
    active: {
      main: "#E9514E",
    },
    background: {
      paper: "#ffffff",
      default: "#efefef",
      grey: "#F7F7F8",
      red: "#E9514E",
      black: "#000000",
    },
    white: {
      main: "#ffffff",
    },
    error: {
      main: "#e9514e",
    },
  },
  typography: {
    fontFamily: "Poppins, sans-serif",
  },
  components: {
    MuiTypography: {
      ...MuiTypography,
    },
    MuiButton: {
      ...MuiButton,
    },
    MuiLink: {
      ...MuiLink,
    },
    MuiChip: {
      ...MuiChip,
    },
    MuiAvatar: {
      ...MuiAvatar,
    },
    MuiTextField: {
      ...MuiTextField,
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: "14px !important",
        },
        shrink: {
          transform: "translate(12px, -8px) scale(0.88)  !important",
        },
        outlined: {
          transform: "translate(14px, 20px) scale(1)",
        },
      },
    },
    MuiFormControl: {
      ...MuiFormControl,
    },
    MuiDivider: {
      ...MuiDivider,
    },
    MuiAutocomplete: {
      ...MuiAutocomplete,
    },
    MuiFormControlLabel: {
      root: {
        whiteSpace: "nowrap",
      },
    },
    ...MuiTable,
    ...MuiDialog,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
});

export default theme;
